import { addSubDirectoryPrefix } from '../../../utils/src/helper';
import { NAVIGATION_URL_CONSTANTS } from '../../../organisms/SearchResults/lib/config';

export const buildPriceLinkHref = ({
  pageVal,
  propertyID,
  chatHref,
  availabilitySearchUrl,
  isShowFullPrice,
  selectedCurrency,
}: {
  pageVal?: string;
  propertyID: string;
  chatHref: string;
  availabilitySearchUrl?: string;
  isShowFullPrice: boolean;
  selectedCurrency: string;
}) =>
  pageVal === 'chat'
    ? chatHref
    : `${addSubDirectoryPrefix(
        `${availabilitySearchUrl}${NAVIGATION_URL_CONSTANTS.SM_VIEW_RATES_URL}`
      )}${propertyID}&isSearch=true&showFullPrice=${isShowFullPrice}${
        selectedCurrency !== 'default' ? '&redirectedFromSERP=true' : ''
      }`;

export const isDePointsSection = (
  currentLocaleVal: string,
  deLocale: string,
  miniPropertyCard: boolean | undefined,
  isMapViewEnabled: boolean,
  includeMapView = false
) => currentLocaleVal === deLocale && !miniPropertyCard && (!includeMapView || isMapViewEnabled);
